import React, { useState } from "react";
import moment from "moment";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const ACCENT = "#161616";

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  caretColor: "black",
  fontSize: 16, // 16px prevents iOS Safari auto-zoom on focus
  borderRadius: 10,
  border: "1.5px solid #e5e5e5",
  padding: "10px 12px",
};

const OldMinimalSlotBookingForm = ({
  state,
  updateState,
  uploadDetails,
  recaptcha,
  isMobile,
  REACT_APP_SITE_KEY,
}) => {
  const isExpertMode = state.bookingMode === "expert";
  const [selectedNoteOption, setSelectedNoteOption] = useState("");

  const slotLabel = (() => {
    if (isExpertMode) return null;
    const from = state.selectedSlot?.from;
    const date = state.activeIndexData?.value;
    if (!from || !date) return null;
    return `${moment(`2024-01-01T${from}:00`).locale("en").format("LT")}, ${moment(date).locale("en").format("LL")}`;
  })();

  return (
    <form
      onSubmit={uploadDetails}
      className="w-100 d-flex flex-column font-weight-bold slotBookingForm"
      style={{ fontSize: "12px", padding: isMobile ? "1rem" : "1.5rem", boxSizing: "border-box" }}
    >
      <h5
        className="font-weight-bold d-flex align-items-center"
        style={{ fontSize: isMobile ? 15 : 18, lineHeight: 1.3 }}
      >
        <IoArrowBackCircleOutline
          style={{ fontSize: "1.8rem", marginInlineEnd: "10px", cursor: "pointer", flexShrink: 0 }}
          onClick={() => {
            recaptcha?.current?.reset();
            updateState("detailsPage", false);
          }}
        />
        Enter your details for further communication..
      </h5>

      {isExpertMode && state.expertNote && (
        <div
          style={{
            background: "#fffbeb",
            border: "1px solid #fde68a",
            borderRadius: 10,
            padding: "10px 12px",
            marginTop: "0.75rem",
            marginBottom: "0.5rem",
            fontSize: 12,
            color: "#78350f",
            lineHeight: 1.5,
          }}
        >
          <div style={{ fontWeight: 700, color: "#92400e", marginBottom: 4 }}>
            Your availability preference:
          </div>
          {state.expertNote}
        </div>
      )}

      {!isExpertMode && slotLabel && (
        <div
          style={{
            background: "#f5f5f5",
            border: "1px solid #e5e5e5",
            borderRadius: 10,
            padding: "10px 12px",
            marginTop: "0.75rem",
            marginBottom: "0.5rem",
            fontSize: 12,
            color: "#161616",
            fontWeight: 600,
          }}
        >
          📅 Selected slot: {slotLabel}
        </div>
      )}

      <label className="mt-2" style={{ fontSize: 12 }}>Name *</label>
      <input
        style={inputStyle}
        value={state.name}
        type="text"
        placeholder="Enter name"
        required
        onChange={(e) => updateState("name", e.target.value)}
      />

      <label className="mt-2" style={{ fontSize: 12 }}>Email *</label>
      <input
        style={inputStyle}
        value={state.email}
        type="email"
        placeholder="Enter email"
        required
        onChange={(e) => updateState("email", e.target.value?.trim())}
      />

      <label className="mt-2" style={{ fontSize: 12 }}>Phone Number *</label>
      <PhoneInput
        country={"in"}
        containerClass="input-dark"
        value={state.phoneNumber}
        placeholder=""
        countryCodeEditable={false}
        onChange={(phone) => updateState("phoneNumber", phone)}
        required
      />

      

      <label className="mt-2" style={{ fontSize: 12 }}>
        Please share anything that will help prepare for our meeting *
      </label>
      <select
        style={inputStyle}
        value={selectedNoteOption}
        required
        onChange={(e) => {
          setSelectedNoteOption(e.target.value);
          if (e.target.value !== "Other") {
            updateState("description", e.target.value);
          } else {
            updateState("description", "");
          }
        }}
      >
        <option value="" disabled>Select an option</option>
        <option value="I'm looking for general relaxation and mindfulness.">I'm looking for general relaxation and mindfulness.</option>
        <option value="I'm dealing with specific tension/tightness and need relief.">I'm dealing with specific tension/tightness and need relief.</option>
        <option value="I'm a beginner looking for a gentle introduction.">I'm a beginner looking for a gentle introduction.</option>
        <option value="Other">Other (I will type my own notes)</option>
      </select>

      {selectedNoteOption === "Other" && (
        <textarea
          style={{ ...inputStyle, minHeight: "5rem", resize: "vertical", marginTop: "0.5rem" }}
          value={state.description}
          required={selectedNoteOption === "Other"}
          placeholder="Please specify your requirements or notes here..."
          onChange={(e) => updateState("description", e.target.value)}
        />
      )}

      <div style={{ marginTop: isMobile ? "1.5rem" : "2rem", marginBottom: "1rem", display: "flex", justifyContent: isMobile ? "center" : "flex-start" }}>
        <ReCAPTCHA
          size={isMobile ? "compact" : "normal"}
          ref={recaptcha}
          sitekey={REACT_APP_SITE_KEY}
        />
      </div>

      <button
        className="mt-3 font-weight-bold"
        style={{
          backgroundColor: ACCENT,
          color: "#ffffff",
          border: "none",
          borderRadius: "10px",
          padding: isMobile ? "13px 20px" : "10px 20px",
          fontWeight: "600",
          fontSize: "14px",
          cursor: "pointer",
          width: "100%",
        }}
      >
        {isExpertMode
          ? "Request Expert Scheduling →"
          : slotLabel
          ? `Request Slot on ${slotLabel}`
          : "Confirm Booking"}
      </button>
    </form>
  );
};

export default OldMinimalSlotBookingForm;